import React from 'react'
import {
    Col,
    Form,
    FormGroup,
    Label,
    Input,
    Row,
    FormFeedback
} from 'reactstrap';

import '../../components/racks/SyleRack.css'

export const FormRack = (props) => {

    const {
        handleInputChange,
        validaciones,
        methodAction,
        name,
        code,
        slots
    } = props;

    const {
        name_valid,
        code_valid,
        slots_valid,
    } = validaciones;

    return (

        <Form role="form" className='pt-3' onSubmit={methodAction}>

            <div className='form-section'>

                <div className="form-title-container">
                    <h4 className="form-title-custom">
                        Configuración de gradillas
                    </h4>
                </div>

                <Row>

                    <Col md="12">
                        <FormGroup>
                            <Label className="label-custom">
                                Nombre
                                <span className="label-required"> *</span>
                            </Label>

                            <Input
                                type="text"
                                autoComplete="off"
                                name="name"
                                value={name}
                                invalid={name_valid}
                                onChange={handleInputChange}
                                placeholder="Ej. Rack Principal"
                                className="input-custom"
                            />

                            <FormFeedback>
                                Debes llenar este campo
                            </FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>


                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-custom">
                                Código
                                <span className="label-required"> *</span>
                            </Label>

                            <Input
                                type="text"
                                autoComplete="off"
                                name="code"
                                value={code}
                                invalid={code_valid}
                                onChange={handleInputChange}
                                placeholder="Ej. RK-001"
                                className="input-custom"
                            />

                            <FormFeedback>
                                Debes llenar este campo
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                    <Col md="6">
                        <FormGroup>
                            <Label className="label-custom">
                                Espacios
                                <span className="label-required"> *</span>
                            </Label>

                            <Input
                                type="number"
                                autoComplete="off"
                                name="slots"
                                value={slots}
                                invalid={slots_valid}
                                onChange={handleInputChange}
                                placeholder="Ej. 20"
                                className="input-custom"
                            />

                            <FormFeedback>
                                Debe ser mayor a 1
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                </Row>

            </div>

        </Form>
    )
}